module.exports = new __parcel__URL__("footer_cow.09deee31.svg").toString();